import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import parseInt from 'lodash/parseInt'
import isNaN from 'lodash/isNaN'
import usePengumuman from 'data/public/usePengumuman'
import styles from 'views/Pengumuman/Pengumuman.module.scss'
import CardInfo from 'components/Cards/CardInfo'
import { Divider } from 'antd'

export default function DetailPengumuman() {
  const router = useRouter()
  const pengumumanId = parseInt(router.query.pengumumanId as string)
  const editMode = !isNaN(pengumumanId)
  const qPengumuman = usePengumuman({}, { enabled: editMode })
  const dataPengumuman = qPengumuman.data?.[0]

  useEffect(() => {
    if (editMode) {
      qPengumuman.helpers.setQuerySync((helpers) => {
        helpers.filtered.set('id', pengumumanId)
      })
    }
  }, [editMode])

  return (
    <>
      <div className='h-60 bg-pencatar-primary' />

      <CardInfo>
        {qPengumuman.isFetching && (
          <div className='text-center'>
            <LoadingOutlined className='text-3xl text-pencatar-primary' />
          </div>
        )}

        {qPengumuman.isSuccess && (
          <>
            <p className='m-0 text-center text-lg font-bold text-pencatar-primary sm:text-2xl'>
              {dataPengumuman?.judulPengumuman}
            </p>

            <Divider />

            <div
              className={styles.containerPengumuman}
              dangerouslySetInnerHTML={{
                __html: dataPengumuman?.isiPengumuman,
              }}
            />
          </>
        )}
      </CardInfo>
    </>
  )
}
